ratingSnippet("ruk_rating_snippet", {
  store: "ultraceuticals",
  mode: "default",
  color: "#abca37",
  linebreak: false,
  text: "Reviews",
  singularText: "Review",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
